import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import fetch, { fetchConfig } from '@/hooks/fetch';
import { fetchDatasetSettings } from '../actions';

const DatasetSettingsFetch = ({
  category,
  code,
  readStatus,
  fetchData,
}) => {
  fetch.useFetchByCode(fetchData, category, code, readStatus, fetchConfig([category, code, readStatus]));
  return null;
};

export const mapStateToProps = ({
  datasetSettings: { settings },
}, { category, code }) => {
  const { readStatus } = findResult(settings, category, code) || { readStatus: states.NONE };
  return ({ readStatus });
};

export const mapDispatchToProps = {
  fetchData: fetchDatasetSettings,
};

export default connect(mapStateToProps, mapDispatchToProps)(DatasetSettingsFetch);
